<template>
  <header class="genericHeader">
    <div class="logo genericHeader__logo" role="img" aria-label="TriviaPop"></div>
  </header>
</template>

<script>
export default {
  name: "GenericHeader"
};
</script>

<style lang="scss">
  .genericHeader {
    display: flex;
    position: relative;
    padding: 5.3rem 0;
    @media ($medium) {
      padding: 7rem 0;
    }
    &__content {
      margin: auto;
    }
    &__logo {
      @extend %large-logo;
      bottom: -4rem;
    }
  }
</style>
